module.exports = __webpack_public_path__ + "img/Logo.c98d3103.svg";